import * as React from "react";
import * as R from "ramda";
import { REQUEST } from "src/co/sura/config/ajax-wrapper";
import { connect } from "react-redux";
import { DotLoader } from "react-spinners";
import { Col, Row, Glyphicon } from "react-bootstrap";
import { Form } from "react-final-form";
import NumericInput from "../../../general/componentes/NumericInput";
import TextoInputSelector from "../../../general/componentes/TextoInputSelector";
import { Mensaje } from "../../../general/componentes/Mensaje";
import { DatosEnvioMora } from "../modelo/EnvioReporteMora";
import {
    enviarSATMoraIndividual, enviarSATMoraMasivo, descargarPlantillaMasivoMora, limpiarMensajesMora
} from "../modulos/procesarMoraActions";
import { TipoReporte } from "../modelo/TipoReporte";
import TextoAyuda from "../../config_general/componentes/TextoAyuda";
import { periodoReporteMora, tipoReporteMora, poliza as textoAyudaPoliza } from "../../config_general/modelo/TextosAyuda";
import ModalAyudaVentana from "../../config_general/componentes/ModalAyudaVentana";
import { tituloVentanaCargaMora } from "../../config_general/modelo/TextoVentanaAyuda";
import { textoPeriodoCumple } from "../../config_general/modelo/FuncionesComunes";
import { ModalConfirmarEnvioMora } from "./ModalConfirmarEnvioMora";

class EstructuraReporteMora extends React.Component<any, any> {

    constructor(props: any) {
        super(props);

        this.renderEstadoEnvioIndividual = this.renderEstadoEnvioIndividual.bind(this);
        this.renderEstadoEnvioMasivo = this.renderEstadoEnvioMasivo.bind(this);
        this.renderPestañaEstadoCarga = this.renderPestañaEstadoCarga.bind(this);
        this.validarXLS = this.validarXLS.bind(this);

        this.state = {
            ventanaAyuda: false,
            textoPeriodo: "",
            fileUpload: React.createRef(),
            archivo: null,
            archivoCorrecto: false,
            estadoCarga: REQUEST.NONE,
            verModalEnvioMora: false,
            datosEnvioMora: undefined
        };
    }

    componentWillUnmount() {
        this.props.dispatch(limpiarMensajesMora());
    }

    render() {
        return (
            <div>
                <Row>
                    {this.crearVentanaAyuda()}
                    <Form
                        onSubmit={this.onSubmit}
                        validate={this.validate}
                        render={({ handleSubmit, invalid, errors, form, submitting, pristine, values }) => (
                            <form onSubmit={handleSubmit}>
                                <h1 className={"title"}>Envió de Periodo en Mora a SAT
                                    <button type="button" className="btns btns-glyphicon" onClick={this.actualizarModalAyuda}
                                        disabled={this.state.ventanaAyuda}>
                                        <span className="icons-table">
                                            <Glyphicon style={{ left: `10px` }} glyph="question-sign" />
                                        </span>
                                    </button>
                                </h1>
                                <div className={"card"}>
                                    <div className={"card-header"}>
                                        <h3 className={"panel-title"}>Envió individual</h3>
                                    </div>
                                    <div className={"card-body"}>
                                        <Row className={"form-group"}>
                                            <Col sm={3}>
                                                <label htmlFor="numeroPoliza">Póliza</label>
                                                <TextoAyuda texto={textoAyudaPoliza} />
                                                <NumericInput name="numeroPoliza" />
                                            </Col>
                                            <Col sm={2}>
                                                <label htmlFor="periodoMora">Periodo en Mora</label>
                                                <TextoAyuda texto={periodoReporteMora} />
                                                <NumericInput name="periodoMora" />
                                            </Col>
                                            <Col sm={3}>
                                                <label htmlFor="tipoReporte">Tipo Reporte</label>
                                                <TextoAyuda texto={tipoReporteMora} />
                                                <TextoInputSelector name="tipoReporte" maestro={this.listaTiposReporte()} />
                                                {errors.causalRetiro &&
                                                    <div style={{ marginTop: '5px' }}>
                                                        <span className={"text-danger"}>{errors.causalRetiro}</span>
                                                    </div>
                                                }
                                                {this.state.verModalEnvioMora && this.renderModalEnvioMora()}
                                            </Col>
                                            <Col sm={1} style={{ marginTop: '20px' }}>
                                                <button type="button" className="btns btns-link" onClick={form.reset}
                                                    disabled={submitting || pristine}>
                                                    Limpiar
                                                </button>
                                            </Col>
                                            <Col sm={2}>
                                                <br />
                                                <button type="submit" className="btns btns-primary" disabled={submitting || invalid}>
                                                    <b>Enviar Individual</b> &nbsp;<Glyphicon className={"glyphicon-play"} glyph={"glyphicon-play"} />
                                                </button>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                                <Row>
                                    {
                                        this.renderEstadoEnvioIndividual()
                                    }
                                </Row>
                                <br />
                                <div className={"card"}>
                                    <div className={"card-header"}>
                                        <h3 className={"panel-title"}>Envió masivo</h3>
                                    </div>
                                    <div className={"card-body"} style={{ marginTop: '30px' }}>
                                        <Row className={"form-group"}>
                                            <Col sm={3}>
                                                <a className="btns btn-success" onClick={this.descargarPlantillaXLS} >
                                                    <b>Plantilla Excel</b> &nbsp;<Glyphicon className={"download-alt"} glyph={"download-alt"} />
                                                </a>
                                            </Col>
                                            <Col sm={3}>
                                                <a className="btns btn-primary" onClick={this.cargarArchivoXLS} >
                                                    <input type="file" ref={this.state.fileUpload} name="archivo"
                                                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" style={{ display: "none" }} />
                                                    <b>Cargar Excel</b> &nbsp;<Glyphicon className={"upload"} glyph={"upload"} />
                                                </a>
                                            </Col>
                                            <Col smOffset={2} sm={1}>
                                                <button type="button" className="btns btns-link" onClick={this.resetFile}
                                                    disabled={!this.state.archivoCorrecto}>
                                                    Limpiar
                                                </button>
                                            </Col>
                                            <Col sm={2}>
                                                <button className="btns btns-primary" style={{ width: '142px' }} onClick={this.enviarMasivo} disabled={!this.state.archivoCorrecto}>
                                                    <b>Enviar Masivo</b> &nbsp;<Glyphicon className={"glyphicon-play"} glyph={"glyphicon-play"} />
                                                </button>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                                <Row>
                                    {this.renderPestañaEstadoCarga()}
                                    {this.renderEstadoEnvioMasivo()}
                                </Row>
                            </form>
                        )}
                    />
                </Row>
            </div>
        );
    }

    renderEstadoEnvioIndividual() {
        const { estadoEnvioIndividual, mensajeUsuario, poliza, dni, consecutivoMoraNota } = this.props;

        switch (estadoEnvioIndividual) {
            case REQUEST.ERROR:
                return <Mensaje type={"danger"} mensaje={mensajeUsuario ? mensajeUsuario : "Se ha presentado un error, intenta nuevamente!"} />;
            case REQUEST.PENDING:
                return (
                    <div>
                        <DotLoader size={25} />
                    </div>
                );
            case REQUEST.SUCCESS:
                return (
                    <span>
                        <Mensaje type={"success"}
                            mensaje={` Se realizó la carga de la información con exito; póliza: ${poliza}, dni: ${dni}, consecutivo proceso: ${consecutivoMoraNota}.`}
                        />
                    </span>
                );
            default:
                return false;
        }
    }

    renderPestañaEstadoCarga() {
        switch (this.state.estadoCarga) {
            case REQUEST.ERROR:
                return <Mensaje type={"danger"} mensaje={" El archivo no se cargó porque no cumple con el formato o el tamaño de 1 Megabytes."} />;
            case REQUEST.PENDING:
                return (
                    <div>
                        <DotLoader size={25} />
                    </div>
                );
            case REQUEST.SUCCESS:
                return (
                    <span>
                        <Mensaje type={"success"} mensaje={" El archivo se cargó con exito."} />
                    </span>
                );
            default:
                return false;
        }
    }

    renderEstadoEnvioMasivo() {
        const { estadoEnvioMasivo, mensajeUsuario, consecutivoMoraNota } = this.props;

        switch (estadoEnvioMasivo) {
            case REQUEST.ERROR:
                return <Mensaje type={"danger"} mensaje={mensajeUsuario ? mensajeUsuario : "Se ha presentado un error, intenta nuevamente!"} />;
            case REQUEST.PENDING:
                return (
                    <div>
                        <DotLoader size={25} />
                    </div>
                );
            case REQUEST.SUCCESS:
                return (
                    <span>
                        <Mensaje type={"success"}
                            mensaje={`Se realizó la carga de la información con exito; consecutivo proceso: ${consecutivoMoraNota}.`}
                        />
                    </span>
                );
            default:
                return false;
        }
    }

    crearVentanaAyuda = () => {
        return (
            <ModalAyudaVentana
                titulo={tituloVentanaCargaMora}
                visible={this.state.ventanaAyuda}
                onCancelar={this.actualizarModalAyuda}
            >
                <p style={{ color: "#000000" }}>Por medio de esta ventana podrás enviar a SAT a marcar o desmarcar de forma individual o masiva periodos en mora de las empresas
                    de las siguientes formas:
                    <br />
                    <br />
                    <strong>Individual: </strong>Ingresando los datos de envió individual y dando clic en el botón Enviar individual.
                    <br />
                    <br />
                    <strong>Masivo: </strong>Descargar la plantilla de Excel, diligenciar los datos en esta de los periodos en mora que se enviaran  y guardar los cambios,
                    luego con el botón de cargar Excel se busca el documento con el nombre que se guardó y se selecciona, por último se da clic en el botón Enviar Masivo.
                </p>
            </ModalAyudaVentana >
        );
    }

    actualizarModalAyuda = () => {
        this.setState({ ventanaAyuda: !this.state.ventanaAyuda });
    }

    validate = (values: any) => {
        const errors = {
            numeroPoliza: undefined,
            periodoMora: undefined,
            tipoReporte: undefined
        };

        if (!values.numeroPoliza)
            errors.numeroPoliza = "Por favor ingresa el numero de poliza";

        if (values.numeroPoliza && !values.periodoMora)
            errors.periodoMora = "Por favor ingrese un periodo de reporte";

        if (values.numeroPoliza && values.periodoMora && !textoPeriodoCumple(values.periodoMora))
            errors.periodoMora = "El texto del periodo no cumple con el formato.";

        if (values.numeroPoliza && values.periodoMora && !values.tipoReporte)
            errors.tipoReporte = "Por favor seleccione el tipo de reporte";

        return errors;
    };

    onSubmit = (values: any) => {
        const poliza = values.numeroPoliza ? values.numeroPoliza : undefined;
        const periodoMora = values.periodoMora ? values.periodoMora : undefined;
        const tipoReporte = values.tipoReporte ? values.tipoReporte.value : undefined;

        const textoPeriodo = texto => texto.substr(0, 4).concat("-", texto.substr(4));

        const datosEnvioMora: DatosEnvioMora = {
            poliza: poliza,
            periodo: textoPeriodo(periodoMora),
            tipoReporte: tipoReporte,
            justificacion: '',
            dniUsuarioOperacion: this.props.dniUsuarioGestionLogin
        };

        this.setState({
            datosEnvioMora: datosEnvioMora,
            verModalEnvioMora: true
        });
    };

    renderModalEnvioMora(){
        return (
            <ModalConfirmarEnvioMora
                datosEnvio={this.state.datosEnvioMora}
                cerrarModal={this.cerraModalEnvioMora}
                procesarEnvio={this.procesarEnvio}
            />);
    }

    cerraModalEnvioMora = () => {
        this.setState({verModalEnvioMora: false});
    }

    procesarEnvio = (datosEnvioMora: DatosEnvioMora) => {
        this.props.dispatch(enviarSATMoraIndividual(datosEnvioMora));
    }

    enviarMasivo = () => {
        if (this.state.archivoCorrecto) {
            this.props.dispatch(enviarSATMoraMasivo(this.state.archivo));
        }
        this.resetFile();
    }

    descargarPlantillaXLS = () => {
        this.props.dispatch(descargarPlantillaMasivoMora());
    }

    resetFile = () => {
        this.setState({
            estadoCarga: REQUEST.NONE,
            archivo: null,
            archivoCorrecto: false
        });
    }

    cargarArchivoXLS = () => {
        const fileUpload = this.state.fileUpload.current;
        fileUpload.value = null;
        fileUpload.click();
        fileUpload.onchange = (e) => {
            this.validarXLS(e.target.files[0]);
        };
    }

    validarXLS(file: File) {
        if (file) {
            const nombre = file.name;
            const extencion = nombre.substring(nombre.length - 4, nombre.length);
            const tamano = file.size;
            if (extencion !== "xlsx" || tamano > 1000000) {
                this.setState({
                    estadoCarga: REQUEST.ERROR,
                    archivo: null,
                    archivoCorrecto: false
                });
                return;
            }
            this.setState({
                estadoCarga: REQUEST.SUCCESS,
                archivo: file,
                archivoCorrecto: true
            });
        }
    }

    listaTiposReporte = () => {
        return [].concat(
            TipoReporte.map(value => ({
                value: value.codigoReporte,
                label: value.nombreReporte
            })
            ));
    }
}

export default connect((store: any) => {
    return {
        dniUsuarioGestionLogin: R.pathOr(undefined, ["inicio", "dniLogin"])(store),
        estadoEnvioIndividual: R.pathOr([], ["estructura_mora", "estadoEnvioIndividual"])(store),
        estadoEnvioMasivo: R.pathOr([], ["estructura_mora", "estadoEnvioMasivo"])(store),
        mensajeUsuario: R.pathOr(undefined, ["estructura_mora", "mensajeUsuario"])(store),
        poliza: R.pathOr(undefined, ["estructura_mora", "poliza"])(store),
        dni: R.pathOr(undefined, ["estructura_mora", "dni"])(store),
        consecutivoMoraNota: R.pathOr(undefined, ["estructura_mora", "consecutivoMoraNota"])(store)
    };
})(EstructuraReporteMora);


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/procesar_mora/componentes/EstructuraReporteMora.tsx